module.exports = "https://assets.niwcorp.com/_next/static/images/ico-linkedin-0683e39f5cb2997b13efe6137de5ea86.svg";